module.exports = __webpack_public_path__ + "static/dsl.fa28c581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/dsl.svg
// module id = 2170
// module chunks = 61762850755587